import { apiRequest } from '../../../shared/services/apiClient';
import {
  MicrosoftTeamsMeeting,
  MicrosoftTeamsOAuthStartResponse,
  MicrosoftTeamsSettings,
} from '../types/microsoftTeams';

const asOptionalText = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed ? trimmed : null;
};

const asSettings = (payload: any): MicrosoftTeamsSettings => ({
  oauthConfigured: Boolean(payload?.oauthConfigured),
  connected: Boolean(payload?.connected),
  connectedUserPrincipalName: asOptionalText(payload?.connectedUserPrincipalName),
  connectedDisplayName: asOptionalText(payload?.connectedDisplayName),
  azureTenantId: asOptionalText(payload?.azureTenantId),
  connectedAt: asOptionalText(payload?.connectedAt),
});

export const getMicrosoftTeamsSettings = async (): Promise<MicrosoftTeamsSettings> => {
  const payload = await apiRequest<any>('/api/v1/connectors/microsoft-teams/settings');
  return asSettings(payload);
};

export const startMicrosoftTeamsOAuth = async (): Promise<MicrosoftTeamsOAuthStartResponse> => {
  const payload = await apiRequest<any>('/api/v1/connectors/microsoft-teams/oauth/start', {
    method: 'POST',
  });

  return {
    authorizeUrl: asOptionalText(payload?.authorizeUrl) || '',
  };
};

export const disconnectMicrosoftTeams = async (): Promise<MicrosoftTeamsSettings> => {
  const payload = await apiRequest<any>('/api/v1/connectors/microsoft-teams/disconnect', {
    method: 'POST',
  });
  return asSettings(payload);
};

export const createMicrosoftTeamsTestMeeting = async (): Promise<MicrosoftTeamsMeeting> => {
  const payload = await apiRequest<any>('/api/v1/connectors/microsoft-teams/test-meeting', {
    method: 'POST',
  });

  return {
    meetingId: asOptionalText(payload?.meetingId) || '',
    subject: asOptionalText(payload?.subject) || '',
    startAtUtc: asOptionalText(payload?.startAtUtc) || '',
    endAtUtc: asOptionalText(payload?.endAtUtc) || '',
    joinUrl: asOptionalText(payload?.joinUrl) || '',
  };
};
